import { render, staticRenderFns } from "./StudentFinanceOffer.vue?vue&type=template&id=61bf0278&scoped=true"
import script from "./StudentFinanceOffer.vue?vue&type=script&lang=js"
export * from "./StudentFinanceOffer.vue?vue&type=script&lang=js"
import style0 from "./StudentFinanceOffer.vue?vue&type=style&index=0&id=61bf0278&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "61bf0278",
  null
  
)

export default component.exports